import { z } from 'zod';

import type {
  HistoryEntityType,
  HistoryType,
  IdHeaderTagDto,
  IdPlacementDto,
  IntegrationType,
  IdUserDto,
} from '@/services/ws-header-tag/src/main/resources/rest-api';
import type { DateRangeType } from '@/js/libs/ui/src/V2';

import type { HistoryEditAction } from 'src/modules/History/types.ts';
import type { Option } from 'src/types.ts';

export interface PlacementsHistoryRouteParams {
  integrationType: IntegrationType;
  headerTagId: IdHeaderTagDto;
}

export enum PlacementsHistorySearchKey {
  PLACEMENT_ID = 'placementId',
}

export const PlacementsHistorySearchParams = z.object({
  [PlacementsHistorySearchKey.PLACEMENT_ID]: z.custom<IdPlacementDto>().optional(),
});

export type PlacementsHistorySearchParams = z.infer<typeof PlacementsHistorySearchParams>;

export type PlacementsHistoryFiltersState = {
  search: string;
  userId: Option<IdUserDto> | null;
  dateRange: DateRangeType | null;
  historyType: Option<HistoryType> | null;
  entityType: Option<HistoryEntityType> | null;
  placementId: Option<IdPlacementDto> | null;
  includeInactive: boolean;
};

export type PlacementsHistoryFilterOptions = {
  users: Option<IdUserDto>[];
  historyTypes: Option<HistoryType>[];
  entityTypes: Option<HistoryEntityType>[];
  minDate?: Date;
  maxDate?: Date;
};

export type PlacementsHistoryContextParams = {
  headerTagId: IdHeaderTagDto;
};

export type PlacementsHistoryContentProps = {
  editAction: HistoryEditAction;
  headerTagId: IdHeaderTagDto;
};
